import ListView from '../../../components/ListView';

const breadcrumbItems = [
  { label: 'Home', href: '/dashboard' },
  { label: 'Jobs' },
];

export default function JobsListPage() {
  const action = [{ name: 'Add Notes & Share', route: '/popup/add-notes', popupState: { notesfor: 'candidate' } }];
  return <ListView moduleName="job" breadcrumbItems={breadcrumbItems} actions={action} />;
}
